import { call, put, select } from 'redux-saga/effects';
import { selectFormById } from 'store/formControl/formControlSelectors';
import { formControlActions } from 'store/formControl/formControlSlice';
import * as authorizedCompanySelectors from 'store/companyAuthorizedList/companyAuthorizationListSelectors';

import { store } from 'store/store';
import notificationsHandler from 'utils/notificationsHandler';
import { axiosLasta } from 'config';

export function* FormCompanySaga({ payload: type }) {
    try {
        const formId = type.formId;
        const {
            form: { values, errors },
        } = yield select(selectFormById(formId));
        let isFormValid = true;

        Object.keys(errors).forEach((fieldName) => {
            if (errors[fieldName]) {
                isFormValid = false;
                store.dispatch(formControlActions.setFieldTouched({ formId, fieldName }));
            }
        });

        if (!isFormValid) {
            yield notificationsHandler({
                title: 'Please fill required fields',
                variant: 'warning',
            });
            return;
        }

        let message;

        if (type.formStatus === 'add') {
            if (type.formId === 'peopleAuthrizedAddAlerts') {
                const authorizations = yield select(authorizedCompanySelectors.selectAuthoriziedItemAlerts);
                const data = {
                    ...type.authorizedOrganization,
                    ...type.location,
                    authType: {
                        id: values.name,
                    },
                };

                if (values.authorizedBy) {
                    data.authorizedBy = {
                        id: values.authorizedBy,
                    };
                }
                if (values.authorizedVia) {
                    data.authorizedVia = values.authorizedVia;
                }
                if (values.note) {
                    data.note = values.note;
                }
                if (authorizations.find((el) => el.id === values.name)) {
                    yield notificationsHandler({
                        title: 'Authorization already exist for company',
                    });
                    return;
                } else {
                    const response = yield axiosLasta.post(type.postUrl, data);
                    ({ message } = response.data);
                }
            } else {
                yield put(type.actions.setAddingCompanyInProgress(true));
                const response = yield axiosLasta.post(type.postUrl, values);
                if (response.status === 200) {
                    yield put(type.actions.setAddedCompany(true));
                    yield put(type.actions.setAddingCompanyInProgress(false));
                }
                ({ message } = response.data);
            }
        }
        if (type.formStatus === 'edit') {
            const beforeEditData = type.beforeEditData;

            const hasChanged = Object.keys(values).reduce((hasChanged, fieldName) => {
                let setHasChanged = false;

                if (typeof values[fieldName] === 'object' && values[fieldName]?.name !== beforeEditData[fieldName]?.name) {
                    setHasChanged = true;
                }

                if (
                    (typeof values[fieldName] === 'string' || typeof values[fieldName] === 'number' || values[fieldName] === null) &&
                    values[fieldName] !== beforeEditData[fieldName]
                ) {
                    setHasChanged = true;
                }

                return !hasChanged ? setHasChanged : true;
            }, false);

            if (!hasChanged) {
                yield call(notificationsHandler, {
                    title: 'No changes detected',
                    variant: 'info',
                });
                return;
            }

            const response = yield axiosLasta.put(type.putUrl, {
                ...values,
                id: beforeEditData.id,
            });
            ({ message } = response.data);
        }

        if (message.includes('already exist')) {
            yield put(
                formControlActions.setFieldError({
                    formId,
                    fieldName: type.fields.name.fieldName,
                    error: `${type.formFor} already exists`,
                })
            );
            return;
        }

        if (message.includes('SUCCESS') && type.formId === 'peopleInfo') {
            yield put(type.actions.fetchMasterListStart());

            yield notificationsHandler({
                title: `SUCCESSFULLY ADDED COMPANY TO MASTER LIST`,
                variant: 'success',
            });
        }

        if (message.includes('SUCCESS') && type.formId === 'peopleAuthrizedPersonInfo') {
            yield put(type.actions.setFormStatus('viewOnly'));
            yield put(type.actions.fetchAuthorizedListPerLocation(type.locationId));

            yield notificationsHandler({
                title: `SUCCESSFULLY ${type.formStatus === 'edit' ? 'EDITED' : 'ADDED'} AUTHORIZATION FOR COMPANY`,
                variant: 'success',
            });
        }

        if (message.includes('SUCCESS') && type.formId === 'peopleAuthrizedAddAlerts') {
            yield put(type.actions.setAddAuthTypePopupVisible(false));
            yield put(type.actions.fetchAuthorizedListPerLocation(type.locationId));
            const getAuthTypeIds = {
                personId: type.authorizedOrganization.authorizedOrganization.id,
                locationId: type.locationId.id,
            };

            if (type.successId === 'addAuthorizationAlert') {
                yield put(type.actions.fetchAuthorizedItemAuthTypesStart(getAuthTypeIds));
            }

            if (type.successId === 'addAuthorizationPerson') {
                yield put(type.actions.fetchAuthorizedItemAuthTypesStart(getAuthTypeIds));
                yield put(type.actions.setAuthTypePopupVisible(false));
                yield put(type.actions.setSelectedMasterListItem(type.authorizedOrganization.authorizedOrganization.id));
                yield put(type.actions.setSelectedAuthorizedItem(type.authorizedOrganization.authorizedOrganization.id));
            }

            yield notificationsHandler({
                title: `SUCCESSFULLY ADDED AUTHORIZATION FOR COMPANY`,
                variant: 'success',
            });
        }
    } catch (err) {
        yield notificationsHandler({
            title: `Error submitting data! ${err.message}`,
        });
        yield put(type.actions.submitFormFailed(JSON.stringify(err.message)));
    }
}
